import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CreatePaymentViewDto } from "../../models/payment-view.models";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { ModalService } from "../../../../services/modal.service";
import { PaymentViewDataService } from "../../services/payment-view-data.service";
import { iinValidator } from "../../../../validators/iin.validator";
import { PermissionService } from "src/app/services/permission.service";

@Component({
	selector: "app-edit-payment-view-dialog",
	templateUrl: "./edit-payment-view-dialog.component.html",
	styleUrls: ["./edit-payment-view-dialog.component.scss", "../add-payment-view-dialog/add-payment-view-dialog.component.scss"],
})
export class EditPaymentViewDialogComponent implements OnInit, OnDestroy {
	@Input() paymentId?: number;

	@Output() sendEvent: EventEmitter<void> = new EventEmitter<void>();

	form!: FormGroup;

	isActivePayment = true;

	subs: Subscription[] = [];

	isSending = false;

	constructor(
		private modalService: ModalService,
		private paymentViewDataService: PaymentViewDataService,
		public permissionService: PermissionService
	) {}

	ngOnInit() {
		this.initForm();
		this.updateFormData();
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	updateFormData() {
		this.subs.push(
			this.paymentViewDataService.loadDetailPaymentView(this.paymentId!).subscribe({
				next: (res) => {
					this.isActivePayment = !res.is_blocked;
					this.form.patchValue({
						accountRecipient: res.recipient_account,
					});
					this.form.patchValue({
						paymentNameFormControl: res.payment_type_name,
					});
					this.form.patchValue({
						paymentNameFormControl: res.payment_type_name,
					});
					this.form.patchValue({ recipientFormControl: res.recipient });
					this.form.patchValue({ binFormControl: res.BIN_beneficiary });
					this.form.patchValue({
						codeFormControl: res.budget_classification_code.toString(),
					});
					this.form.patchValue({
						codeDestinationFormControl: res.payment_purpose_code.toString(),
					});
					this.form.patchValue({
						bankRecipient: res.recipient_bank.toString(),
					});
					this.form.patchValue({
						moneyRemitter: res.money_remitter_code.toString(),
					});
					this.form.patchValue({
						infoLine: res.info_line.toString(),
					});
				},
			})
		);
	}

	initForm(): void {
		this.form = new FormGroup({
			accountRecipient: new FormControl("", [Validators.required]),
			paymentNameFormControl: new FormControl("", [Validators.required]),
			recipientFormControl: new FormControl("", [Validators.required]),
			binFormControl: new FormControl("", [Validators.required, Validators.minLength(12), iinValidator()]),
			codeFormControl: new FormControl("", [Validators.minLength(6)]),
			codeDestinationFormControl: new FormControl("", [Validators.required, Validators.minLength(3)]),
			bankRecipient: new FormControl("", [Validators.required, Validators.minLength(8)]),
			moneyRemitter: new FormControl("", [Validators.required]),
			infoLine: new FormControl("", [Validators.required]),
		});
	}

	get infoLineRequiredError() {
		return this.form.get("infoLine")?.hasError("required");
	}

	get accountRecipientRequiredError() {
		return this.form.get("accountRecipient")?.hasError("required");
	}

	get paymentNameRequiredError() {
		return this.form.get("paymentNameFormControl")?.hasError("required");
	}

	get recipientRequiredError() {
		return this.form.get("recipientFormControl")?.hasError("required");
	}

	get binRequiredError() {
		return this.form.get("binFormControl")?.hasError("required");
	}

	get binFormatError() {
		return this.form.get("binFormControl")?.hasError("minlength");
	}

	get codeFormFormatError() {
		return this.form.get("codeFormControl")?.hasError("minlength");
	}

	get codeDestinationRequiredError() {
		return this.form.get("codeDestinationFormControl")?.hasError("required");
	}

	get codeDestinationFormatError() {
		return this.form.get("codeDestinationFormControl")?.hasError("minlength");
	}

	get bankRecipientRequiredError() {
		return this.form.get("bankRecipient")?.hasError("required");
	}

	get bankRecipientFormatError() {
		return this.form.get("bankRecipient")?.hasError("minlength");
	}

	get moneyRemitterFormatError() {
		return this.form.get("moneyRemitter")?.hasError("required");
	}

	sendForm() {
		this.isSending = true;
		const data: CreatePaymentViewDto = {
			recipient_account: this.form.get("accountRecipient")?.value,
			is_blocked: !this.isActivePayment,
			payment_type_name: this.form.get("paymentNameFormControl")?.value,
			BIN_beneficiary: this.form.get("binFormControl")?.value,
			recipient: this.form.get("recipientFormControl")?.value,
			budget_classification_code: this.form.get("codeFormControl")?.value,
			payment_purpose_code: this.form.get("codeDestinationFormControl")?.value,

			recipient_bank: this.form.get("bankRecipient")?.value,
			money_remitter_code: this.form.get("moneyRemitter")?.value,

			info_line: this.form.get("infoLine")?.value,
		};
		if (this.paymentId) {
			this.paymentViewDataService.editPaymentView(data, this.paymentId).subscribe({
				next: () => {
					this.sendEvent.emit();
					this.isSending = false;
					this.modalService.closeModal();
				},
				error: () => {
					this.isSending = false;
				},
			});
		}
	}

	closeModal() {
		this.modalService.closeModal();
	}
}
